module.exports = __webpack_public_path__ + "static/img/t4.575cdfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic/t4.jpg
// module id = KepC
// module chunks = 11